import {SourcingType} from '../../../hooks/useSourcingType';
import {type FiltersType} from '../types/FiltersType';
import {areVanDimensionFiltersVisible} from './areVanDimensionFiltersVisible';
import {getAppliedVehicleCategory} from './getAppliedVehicleCategory';
import {isOriginCountryFilterVisible} from './isOriginCountryFilterVisible';

type ApplicableFiltersFlags = {
  isVanFiltersEnabled: boolean;
  isOriginCountryFilterEnabled: boolean;
  isSuspiciousVehiclesEnabled: boolean;
  isSuspiciousReasonFilterEnabled: boolean;
};

/**
 * Filters that actually apply on the active tab. Van filters (flag off, auctions, or length /
 * height for a passenger-car search) and the origin country (flag off or auctions) stay in the
 * shared state when they do not apply, but they have no chip there, so they must not make the
 * filter UI look active either.
 */
export const getApplicableFilters = (
  filters: FiltersType,
  sourcingType: SourcingType,
  {
    isVanFiltersEnabled,
    isOriginCountryFilterEnabled,
    isSuspiciousVehiclesEnabled,
    isSuspiciousReasonFilterEnabled,
  }: ApplicableFiltersFlags
): FiltersType => {
  const isVanDimensionFilterVisible = areVanDimensionFiltersVisible(
    filters.vehicleCategory,
    sourcingType,
    isVanFiltersEnabled
  );

  return {
    ...filters,
    vehicleCategory: isVanFiltersEnabled
      ? getAppliedVehicleCategory(filters.vehicleCategory, sourcingType)
      : null,
    vehicleLengthCategory: isVanDimensionFilterVisible ? filters.vehicleLengthCategory : undefined,
    vehicleHeightCategory: isVanDimensionFilterVisible ? filters.vehicleHeightCategory : undefined,
    originCountry: isOriginCountryFilterVisible(sourcingType, isOriginCountryFilterEnabled)
      ? filters.originCountry
      : undefined,
    hideSuspicious: isSuspiciousVehiclesEnabled && filters.hideSuspicious,
    excludeSuspiciousReasons:
      isSuspiciousReasonFilterEnabled && !filters.hideSuspicious
        ? filters.excludeSuspiciousReasons
        : undefined,
  };
};
